import { Injectable, Injector } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { UserService } from './user.service';

@Injectable()
export class MessagingService {
  currentMessage = new BehaviorSubject(null);
  userService = this.injector.get(UserService);
  lastMessage = null;

  notifications: any = [];
  notificationsMessage: any = [];
  notificationSelected: any;

  constructor(private injector: Injector, private afMessaging: AngularFireMessaging) {}

  requestPermission(): Promise<string | void> {
    return new Promise((resolve, reject) => {
      this.afMessaging.getToken.subscribe(
        (token) => resolve(token),
        (err) => {
          console.error('Unable to get permission to notify.', err);
          this.afMessaging.getToken.subscribe(
            (token) => resolve(token),
            (vapidErr) => {
              console.error('Unable to get permission with VAPID key:', vapidErr);
              resolve();
            }
          );
        },
      );
    });
  }

  receiveMessage() {
    this.afMessaging.messages.subscribe((payload: any) => {
      const last = this.currentMessage.getValue();
      if (last !== JSON.stringify(payload)) {
        if ('Notification' in window && Notification.permission === 'granted') {
          new Notification(payload.notification.title, { 
            body: payload.notification.body 
          });
        }
        
        let noti = {
          title: payload.notification.title,
          activity: 'conversation',
          body: payload.notification.body,
          createdAt: moment().format('hh:mm a'),
        };

        if(this.notificationsMessage == null) this.notificationsMessage = [];
        this.notificationsMessage.push(noti);
        localStorage.setItem('messages_notifications', JSON.stringify(this.notificationsMessage));
        
        this.currentMessage.next(JSON.stringify(payload));
      }
    });
  }

  getNotificationMessages() {
    if (JSON.parse(localStorage.getItem('messages_notifications')) != '"null"') {
      this.notificationsMessage = JSON.parse(localStorage.getItem('messages_notifications'));
    }
  }

  deleteNotificationMessages() {
    localStorage.removeItem('messages_notifications');
    this.notificationsMessage = [];
    this.notificationSelected = null;
  }
}
